import React, { useState, useEffect, createRef } from 'react'
import axios from 'axios'




function SearchForm () {

    const BACKEND_URL = process.env.REACT_APP_SERVER_URL || window.env.REACT_APP_SERVER_URL;
    const searchUrl = `${BACKEND_URL}/v1/ops/search`

    const useFocus = () => {
        const htmlElRef = createRef(null)
        const setFocus = () => {htmlElRef.current &&  htmlElRef.current.focus()}
        const removeFocus = () => {htmlElRef.current &&  htmlElRef.current.blur()}
        return [ htmlElRef, setFocus, removeFocus ] 
    }

    const [results, setResults] = useState([])
    const [query, setQuery] = useState('')
    const [open, setOpen] = useState(false)
    const [focus, setFocus] = useState(false)
    const [inputRef, setInputFocus, removeFocus] = useFocus()


    const checkSearch = (e) => {
        if (
            e.key === '/' 
            && ( 
                e.srcElement.localName === 'body' || 
                e.srcElement.id === 'search-form' || 
                e.srcElement.localName === 'main'
            ) 
            && query.length <= 0
        ) {
            if (!focus){
                setInputFocus()
                setFocus(true)
                setOpen(true)
            } else{
                removeFocus()
                setFocus(false)
                setOpen(false)
            }
        }
    }

    const checkClickSearch = (e) => {
        if ( 
            e.srcElement.id !== 'search-form' && 
            e.srcElement.id !== 'search-results'
        ) {
            if (focus || open){
                removeFocus()
                setFocus(false)
                setOpen(false)
            }
        }
    }

    useEffect(() => {  
        window.addEventListener("keydown", checkSearch, true);  
        return () => window.removeEventListener("keydown", checkSearch, true);
    }, [checkSearch]);

    useEffect(() => {  
        window.addEventListener("click", checkClickSearch, true);  
        return () => window.removeEventListener("click", checkClickSearch, true);
    }, [checkClickSearch]);


    const search = async (q) => {
        if (q.length > 0){
            await axios.get(`${searchUrl}?query=${q}`)
                .then((r) => {
                    setResults(r.data)
                })
                .catch((e) => {
                    console.log(e)
                })
        }
        
    }


    const getColors = (type) => {
        console.log(type)
        let colors = '' 
        switch (type){
            case 'site':
                colors = 'dark:bg-blue-600 bg-blue-100 dark:text-white text-blue-700'
                break
            case 'page':
                colors = 'bg-gray-200 dark:bg-gray-600 dark:text-white text-gray-700'
                break
            case 'case':
                colors = 'bg-gray-300 dark:bg-gray-500 dark:text-white text-gray-700'
                break
            case 'issue':
                colors = 'text-orange-700 bg-orange-100 dark:text-white dark:bg-orange-600'
                break
            case 'flow':
                colors = 'bg-gray-500 dark:bg-gray-900 dark:text-white text-gray-50'
                break
            default:
                colors = 'bg-gray-200 dark:bg-gray-600 dark:text-white text-gray-700'
                break
        }
        return colors
    }




    return(
        <div>
            <div className='w-full relative'>

                <input 
                    className={`w-full ${open ? 'rounded-t-md border-blue-600 border-b-transparent' : 'rounded-md border-transparent'} border p-2 text-sm dark:text-gray-400 text-gray-600 dark:bg-gray-900 ring-0 bg-gray-100`}
                    placeholder="press `/` to search"
                    value={query}
                    id='search-form'
                    type='search'
                    onFocus={() => {
                        if (!open){
                            setOpen(true)
                        }
                    }}
                    onChange={(e) => {
                        setQuery(e.target.value === '/' ? '' : e.target.value)
                        if (e.target.value !== '') {
                            setOpen(true)
                            search(e.target.value);
                        } else {
                            setOpen(false)
                        }
                    }}
                    ref={inputRef}
                />

                {query.length >= 1 && open &&
                    <div id='search-results' className={`absolute top-full inset-x-0 box-border z-50 shadow rounded-b-lg p-4 bg-white dark:bg-gray-800 dark:text-gray-400 text-gray-600 border-t-0 border-l border-b border-r border-blue-600 overflow-x-scroll`}>

                        { results && 

                            results.slice().map((resource, i) => (
                                <a key={i} href={resource.path}>
                                <div 
                                    className="flex justify-start px-2 py-2 dark:hover:bg-gray-700 hover:bg-gray-100 my-2 rounded-md cursor-pointer" 
                                    onClick={() => {
                                        setQuery('')
                                        setOpen(false)
                                    }}
                                >   
                                    <div className='mr-3 my-auto'>
                                        <div className={`text-center px-2 py-1 rounded-full text-[8px] font-bold ${getColors(resource.type)}`}>
                                            <span>
                                                {resource.type.toUpperCase()}
                                            </span>
                                        </div>
                                    </div>
                                    <div>
                                        <h2 className="font-semibold text-sm">
                                            {resource.str}
                                        </h2>
                                    </div>

                                </div> 
                                </a>
                            ))

                        }

                    </div>
                }

                {query.length < 1 && open &&
                    <div id='search-results' className={`absolute top-full inset-x-0 box-border z-50 shadow rounded-b-lg p-4 bg-white dark:bg-gray-800 dark:text-gray-400 text-gray-600 border-t-0 border-l border-b border-r border-blue-600 overflow-x-scroll`}>

                        <h2 className="font-semibold text-lg">
                            Start typing to search...
                        </h2>

                        <div className='text-[12px] my-6'>
                            <pre>
                                <code>
                                    <p className='mb-2'>- <span className='rounded p-1 bg-gray-100 dark:bg-gray-700'>case:log in</span></p>
                                    <p className='mb-2'>- <span className='rounded p-1 bg-gray-100 dark:bg-gray-700'>flow:large flow</span></p>
                                    <p className='mb-2'>- <span className='rounded p-1 bg-gray-100 dark:bg-gray-700'>site:example.com</span></p>
                                    <p className='mb-2'>- <span className='rounded p-1 bg-gray-100 dark:bg-gray-700'>page:example.com/page</span></p>
                                    <p className='mb-2'>- <span className='rounded p-1 bg-gray-100 dark:bg-gray-700'>issue:new issue</span></p>
                                </code>
                            </pre>
                        </div>
                        
                    </div>
                }
            </div>
            

        </div>
    )

}


export default SearchForm
